<template>
    <div class="configDetails">
        <ResumeCard v-for="(item,i) in resumeData.configSelected" :key="i"
        :cardKey="i"
        :cardTitle="item.label"
        :colorImg="item.colorImg"
        :colorDesignation="item.designation"
        :price="parseFloat(item.price).toFixed(2)"
        :route="item.route"
    />
    </div>
</template>
<script>
    import { mapState } from 'vuex';
    import ResumeCard from '../../Cards/ResumeCard/ResumeCard.vue'

    export default {
        name: 'ConfigDetails',
        components: { ResumeCard, },
        props:{
            selectedOpt: {type: Object, default: () =>  { return {}; }},
        },
        computed:{
            ...mapState(['resumeData']),
        },
    }
</script>
<style lang="scss" scoped>
    .configDetails{
        margin-top: 2.5rem;
        & > *:not(:last-child){ margin-bottom: 1.25rem; }
    }
</style>